import React from 'react';
import PropTypes from 'prop-types';
import css from './ReviewSummary.module.css';
import { FormattedMessage } from '../../util/reactIntl';

const ReviewSummary = ({ reviewSummary, listingTitle }) => {
  if (!reviewSummary || typeof reviewSummary.rating !== 'number' || !reviewSummary.content) return null;

  const { content } = reviewSummary;

  return (
    <section className={css.panel} aria-label={`${listingTitle} review summary`}>
      <div className={css.headingGroup}>
        <h4 className={css.heading}>
          <FormattedMessage
            id="ReviewSummary.heading"
            defaultMessage="AI Product Review Summary"
            values={{ listingTitle }}
          />
        </h4>
        <p className={css.subtitle}>
          <FormattedMessage
            id="ReviewSummary.ratingPulledFromSources"
            defaultMessage="This AI-powered summary is based on verified online reviews of this product."
          />
        </p>
      </div>
      <div className={css.summaryBox}>
        <div className={css.left}>
          <div className={css.baseText}>
            <FormattedMessage id="ReviewSummary.basedOnPublicReviews" defaultMessage="Based on public reviews" />
          </div>
        </div>
        <div className={css.right}>
          <p>{content}</p>
        </div>
      </div>
    </section>
  );
};

ReviewSummary.propTypes = {
  reviewSummary: PropTypes.shape({
    content: PropTypes.string.isRequired,
    rating: PropTypes.number.isRequired,
  }),
  listingTitle: PropTypes.string.isRequired,
};

export default ReviewSummary;
